import * as types from "../../ActionType";

const initState = {
    orders: [],
    loadingOrders: true
}

const OrdersReducer = (state = initState, action) => {
    switch (action.type) {
        case types.ADD_ORDER:
            return { ...state, loadingOrders: true }
        case types.GET_ORDERS:
            return { ...state, orders: action.payload, loadingOrders: false }
        case types.DELETE_ORDER:
            return { ...state}
        case types.EDIT_ORDER:
            return { ...state, loadingOrders: true }
        default:
            return state;
    }
};

export default OrdersReducer;

